var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedAiLogoM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2826 30.6629C20.3725 30.6629 26.1199 24.9177 26.1199 17.8306C26.1199 10.7435 20.3725 4.99829 13.2826 4.99829C6.19277 4.99829 0.445312 10.7435 0.445312 17.8306C0.445312 24.9177 6.19277 30.6629 13.2826 30.6629Z",
    fill: "#FFC800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.807 27.3916C14.4474 29.9063 9.71932 30.357 6.69922 28.8506C10.5658 31.1537 15.5305 31.3529 19.7033 28.9453C23.8762 26.5351 26.1867 22.1382 26.1245 17.6392C25.9203 21.0053 23.1641 24.8745 18.807 27.3916Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9102 5.93943C15.7941 7.46815 13.6579 10.3563 10.1373 12.3855C6.61679 14.4171 3.04894 14.823 2.16507 13.2917C2.12772 13.2195 2.09286 13.1399 2.06796 13.0577C1.8389 12.3456 2.11278 11.4244 2.77257 10.4534C2.87963 10.3015 2.98918 10.1521 3.10122 10.0052C4.09714 8.70806 5.35945 7.58268 6.86328 6.71624C8.36711 5.8473 9.97301 5.31947 11.5939 5.10535C11.7831 5.07796 11.9673 5.05805 12.1466 5.0456C13.3168 4.95845 14.2505 5.18253 14.7534 5.73526C14.8131 5.8 14.8654 5.86971 14.9102 5.93943Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3681 7.59268C21.9118 10.2642 18.797 14.9475 13.4141 18.0547C8.03124 21.162 2.4143 21.5155 0.873123 18.844C0.616676 18.3983 0.479737 17.9029 0.45235 17.37C0.385126 19.1652 0.693859 20.9902 1.4134 22.7231C1.52047 22.982 1.63749 23.2385 1.76197 23.4924C1.76695 23.5024 1.77442 23.5148 1.7794 23.5248C2.24499 24.329 2.93217 24.9614 3.78865 25.4195C6.80876 27.0354 11.9153 26.4801 16.6907 23.724C21.4636 20.9678 24.4986 16.8273 24.6107 13.4063C24.6431 12.4403 24.4414 11.5315 23.9808 10.7273C23.8065 10.4659 23.6247 10.2094 23.433 9.96543C22.3002 8.50144 20.891 7.33623 19.3249 6.50464C19.7606 6.79096 20.1141 7.15447 20.3681 7.59268C20.3681 7.59268 20.3706 7.59517 20.3706 7.59766L20.3681 7.59268Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2826 30.6629C20.3725 30.6629 26.1199 24.9177 26.1199 17.8306C26.1199 10.7435 20.3725 4.99829 13.2826 4.99829C6.19277 4.99829 0.445312 10.7435 0.445312 17.8306C0.445312 24.9177 6.19277 30.6629 13.2826 30.6629Z",
    fill: "url(#paint0_radial_47_12215)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_47_12215",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2833 17.8308) scale(12.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.35
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedAiLogoM);
export default __webpack_public_path__ + "static/media/medAiLogoM.91ee13ee1d1200b66e6e603fcdffcfd7.svg";
export { ForwardRef as ReactComponent };